import React from "react";
import { BlackAndWhite, colors } from "../../../themes/Colors";

const TextInputFieldArea = ({
  labelTitle,
  onChange,
  width,
  size,
  invert,
  rule,
  reqiredCheck,
  showPassword,
  autoFocus,
  value,
  placeholder,
  onClick,
  mini,
  height,
  marginTop,
  enter,
  type,
  min,
  count,
  readOnly,
}) => {
  return (
    <form
      onSubmit={
        enter
          ? (e) => {
              e.preventDefault();
              enter();
            }
          : (e) => e.preventDefault()
      }
      style={{
        width: width,
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        flexDirection: "column",
        marginTop: mini ? (marginTop ? marginTop : 10) : 20,
      }}
    >
      <label
        style={{
          width: size ? size : 240,
          fontWeight: "500",
          fontSize: mini ? 14 : 16,
          color: invert ? colors.white : colors.secondaryDarkBlue,

          position: "relative",
        }}
      >
        {labelTitle ? labelTitle : null}
        {reqiredCheck ? (
          <div
            style={{
              position: "absolute",
              right: 0,
              top: 0,
              color: rule === count ? colors.greenLight : colors.orangeDark,
            }}
          >
            {rule + " / " + count}
          </div>
        ) : null}
      </label>

      <textarea
        autoFocus={autoFocus}
        min={min}
        style={{
          height: height ? height : 30,
          width: size ? size : 220,
          marginTop: mini ? 5 : 10,
          borderRadius: mini ? 4 : 50,
          paddingRight: 10,
          paddingTop: 8,
          paddingBottom: 8,
          paddingLeft: 20,
          fontSize: mini ? 12 : 18,
          borderStyle: "none",
          backgroundColor: invert ? "#FFFFFF" : "#00000030",
          color: invert ? colors.white : colors.secondaryDarkBlue,
          fontWeight: "bold",
          // borderWidth: 0.2,
        }}
        readOnly={readOnly}
        type={type ? type : showPassword ? "password" : "text"}
        name={labelTitle}
        onChange={onChange}
        value={value}
        placeholder={placeholder ? placeholder : "type here"}
      />
    </form>
  );
};

export default TextInputFieldArea;
